import React, {Component} from "react"
import PropTypes from "prop-types"
import {Button, ButtonGroup, Glyphicon, Panel} from 'react-bootstrap'
import EventForm, {createEventInitialValues} from '../event/EventForm'
import * as Date from "../../utils/date"
import {EventType, EventTypeLabel} from "../../utils/enums";
import {Enums} from "../../utils";
import {formatEventDescription, getEventExpirationClassName} from "../../utils/format";
import {formatItemActions, renderItemTable} from "./helpers";

class DogEvents extends Component {

	constructor(props) {
		super(props)

		this.state = {
			itemModalOpen: false,
			eventId: null,
			eventTypes: [],
		}

		this.handleItemModalClick = this.handleItemModalClick.bind(this);
		this.handleItemModalDismiss = this.handleItemModalDismiss.bind(this);

		this.tableCtx = {
			itemKeyName: 'eventId',
			cols: [
				{title: 'Datum', width: 17},
				{title: 'Typ', width: 17},
				{title: 'Popis', width: 39},
				{title: 'Provedl', width: 17},
			],
			renderRow: (item, files, props) => {
				const {enums} = props;
				return <tr key={item.eventId} title={item.createdBy && Enums.getEnumTitle(enums, 'user', item.createdBy) + ' ' + Date.formatDateTime(item.createdAt)}
					className={getEventExpirationClassName(item)}>
					<td title={item.eventId}>
						{Date.formatDate(item.eventDate)}
					</td>
					<td>{EventTypeLabel[item.eventType]}</td>
					<td>{formatEventDescription(item, enums, true)}</td>
					<td>
						{item.eventDoctor ? item.eventDoctor : item.eventBy && Enums.getEnumTitle(enums, 'user', item.eventBy)}
					</td>
					<td>{formatItemActions(item, 'eventId', files, this.handleItemModalClick)}</td>
				</tr>;
			},
		};
	}

	componentWillMount() {
		this.props.onFetchData(this.props.dogId)
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.dogId !== this.props.dogId) {
			this.props.onFetchData(nextProps.dogId)
		}
	}

	handleItemModalClick(eventId) {
		this.setState({itemModalOpen: true, eventId})
	}

	handleItemModalDismiss() {
		this.setState({itemModalOpen: false, eventId: null})
	}

	renderItemModal() {
		const {dogId, session} = this.props;
		const {itemModalOpen, eventId} = this.state;
		if (!itemModalOpen) {
			return null
		}

		return <EventForm event={createEventInitialValues(eventId, dogId, session)} modal={{
			onHide: this.handleItemModalDismiss,
			onSuccess: (item) => this.props.onFetchData(item.dogId, true)
		}}/>
	}

	render() {
		const {items} = this.props;
		const {eventTypes} = this.state;

		const filteredItems = items && items.length
			? items.filter(item => !eventTypes.length || eventTypes.indexOf(item.eventType) >= 0)
			: [];
		return <Panel>
			<Panel.Heading>
				<div className={'panel-title'}>
					Úkony
					<ButtonGroup className="pull-right">
						<Button type="button" className="btn btn-default btn-xs" onClick={() => this.handleItemModalClick(null)}><Glyphicon glyph="plus"/> Přidat</Button>
					</ButtonGroup>
					<ButtonGroup className="pull-right" style={{marginRight: "20px"}}>
						{Object.keys(EventType).map(k => {
							let className = (this.state.eventTypes.indexOf(k) >= 0 ? 'btn-success' : '') + ' btn btn-sm';
							const onclick = () => {
								let eventTypes = this.state.eventTypes
								if (eventTypes.indexOf(k) >= 0) {
									eventTypes = eventTypes.filter(t => t !== k);
								} else {
									eventTypes.push(k);
								}
								this.setState({eventTypes});
							}
							return <Button key={k} type="button" className={className} onClick={onclick}>{EventTypeLabel[k]}</Button>
						})}
					</ButtonGroup>
				</div>
			</Panel.Heading>
			<Panel.Body>
				{renderItemTable(this.tableCtx, {...this.props, items: filteredItems})}
				{this.renderItemModal()}
			</Panel.Body>
		</Panel>
	}
}

DogEvents.propTypes = {
	dogId: PropTypes.number.isRequired,
	files: PropTypes.array,
	onFetchData: PropTypes.func.isRequired,
	onShowModal: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
}

export default DogEvents



// WEBPACK FOOTER //
// ./src/components/dog/DogEvents.js